//
// Generated class ServiceChargeRule
//

/// <reference path="ServiceChargeRule_ManagedObject.ts" />

class ServiceChargeRule extends ServiceChargeRule_ManagedObject
{

}
